export default __webpack_public_path__ + "static/media/logo.b2619fd2.svg";